import _ from 'lodash';

export const makeSort = (ary, field) => {
    const temArr = _.cloneDeep(ary);
    if (temArr.length > 0) {
        temArr.sort((a, b) => {
            return a[field] - b[field];
        });
        return temArr;
    } else return [];
};
